
export const cache: Record<string, {
  uuid: string;
  queue: {
    once: boolean
    callback: any
  }[]
}> = {}

/**
 * 创建一个唯一的函数名（在当前页面会话中保障其唯一性即可）。
 * @param extra 可以额外自定义部分字符串。
 * @returns 
 */
export function registerGlobalValue(scheme: string, callback: any, once = true) {

  if (!cache[scheme]) {
    const uuid = '$jsBridgeFn_' + Date.now().toString(16).toUpperCase() + '_' + Math.ceil(Math.random() * 10000).toString(16).toUpperCase()
    cache[scheme] = {
      uuid,
      queue: [{ once, callback }],
    }
  } else {
    cache[scheme].queue.push({ once, callback })
  }

  Object.assign(window, {
    [cache[scheme].uuid]: (data: any) => {

      cache[scheme].queue = cache[scheme].queue.reduce((accu: {
        once: boolean
        callback: any
      }[], curr) => {
        const { once, callback } = curr
        if (!once) {
          accu.push(curr)
        }
        callback(data)
        return accu
      }, [])
    }

  })
  return cache[scheme].uuid

}

